/*
 * @Description: 初始化页面相关的配置
 * @Author: fiveonelei
 * @Date: 2022-04-10 17:20:56
 * @FilePath: /app-monorepo-projects/packages/app-share/src/composable/use-initialize-home-data/use-init-pageconfig.ts
 */
import { EFeedReserveType } from '@/constants/feed';
import { MutationTypes, useStore } from '@/store';
import type { MyStore } from '@/store/index';
import initAegisAndReportPef from '@/libs/ageis';
import { IS_SSR } from '@/utils/env';

/**
 * 初始化页面相关配置的方法
 *
 * @export
 * @return
 */
export default function useInitPageConfig() {
  const store = useStore();
  const initPageConfig = async () => {
    initPageRelBanner(store);
    // 仅在 CSR 执行
    if (!IS_SSR) {
      initAegisAndReportPef('share');
    }
  };
  return {
    initPageConfig,
  };
};

/**
 * @description: 初始化banner
 * @param {MyStore} store
 * @return {*}
 */
function initPageRelBanner(store: MyStore) {
  const { feedsList, activeIndex, banner } = store.state;
  const feed = feedsList[activeIndex]; // 当前展示的feed数据
  if (!feed) return;
  const { h5ShareTitleContent, h5ShareButtonContent } = feed.reserve[EFeedReserveType.exposureMaterialInfo];
  store.commit(MutationTypes.SET_BANNER, {
    value: {
      ...banner || {},
      bannerTxt: h5ShareTitleContent || '',
      btnTxt: h5ShareButtonContent || '打开看看',
    },
  });
};
